var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcHeaderMenu',{attrs:{"id":"contactsmenu","aria-label":_vm.t('core', 'Search contacts')},on:{"open":_vm.handleOpen},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('Contacts',{attrs:{"size":20}})]},proxy:true}])},[_vm._v(" "),_c('div',{attrs:{"id":"contactsmenu-menu"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }